<template>
  <!--投保须知-->
  <div class="user-notes">
    <h4>授权声明书</h4>
    <p>
      <span class="content">
        <b>本人（包括法人及其他合法团体组织或自然人</b>已<b>阅读并充分知晓由</b>华安财产保险股份有限公司重庆分公司提供的<b>电子数据保全法律费用损失保险产品的全部保险责任和除外责任</b>，在本人与 <b>重庆易保全网络科技有限公司</b>发生单笔电子数据保全的交易活动中，为更好地保障自身权益，同意并授权：
      </span>
      <span class="content"><b>由重庆易保全网络科技有限公司作为本人的投保人，向华安财产保险股份有限公司重庆分公司购买单笔电子数据保全法律费用损失保险 ，被保险人为本人。</b></span>
      <span class="content">以上授权自授权之日起 <b>十个工作日</b> 内生效。</span>
    </p>
    <p v-if="$store.getters.hasAuthUser"><span class="content">授权人：{{$store.getters.authUser.username}}</span></p>
    <p><span class="content">授权日期：{{new Date() | format('YYYY-MM-DD')}}</span></p>
    <h4>投保须知</h4>
    <p><b>尊敬的用户：</b></p>
    <p><span class="content">首先感谢使用华安保险的电子数据保全法律费用损失保险，请在投保前认真阅读本须知：</span></p>

    <p>
      <span class="title">一、保险客体 </span>
      <span class="content">  单笔保全数据，表现形式为保全备案号。</span>
    </p>

    <p>
      <span class="title">二、授权</span>
      <span class="content"> 在保险单约定的等待期结束后，在本保险合同期间内，被保险人在投保人平台保全的数据，用于其作为被告、原告参与的民事诉讼、刑事自诉、行政诉讼或仲裁活动的司法举证，对于被保险人应支付的下列法律费用，保险人负责赔偿：</span>
      <span class="content"> （一）	诉讼费用；</span>
      <span class="content">（二） 仲裁费用；</span>
      <span class="content">（三） 执行费用；</span>
      <span class="content">（四） 司法鉴定费用；</span>
      <span class="content">（五） 公证费用；</span>
      <span class="content"> （六） 保全出证费用；</span>
      <span class="content">（七） 法院文书邮寄送达费用</span>
    </p>

    <p>
      <span class="title">四、保险期限</span>
      <span class="content">一年或一年的整数倍，最长不超过3年。 保险起期为用户购买本保险服务的第二天零时起，即T+1。</span>
    </p>

    <p>
      <span class="title">五、赔偿限额</span>
      <span class="content"> 累计赔偿限额RMB1万元，保险期限内赔偿次数1次。</span>
    </p>

    <p>
      <span class="title">六、免赔率：</span>
      <span class="content">每次事故免赔率为损失金额的20%。</span>
    </p>

    <p>
      <span class="title">七、等待期</span>
      <span class="content">30天（指自投保人投保时起至保险合同生效时止之间的时间段，由投保人与保险人协商确定，并在保险单中载明，在等待期内保险人不承担赔偿责任。）</span>
    </p>

    <p>
      <span class="title">八、除外责任</span>
      <span class="content">（一）根据《中华人民共和国法律援助条例》的规定，被保险人可获得法律援助的，保险人对该部分律师代理费用不负责赔偿； </span>
      <span class="content">（二）根据《诉讼费用交纳办法》规定，人民法院准予减免被保险人的诉讼费用的，对于减免部分，保险人不负责赔偿； </span>
      <span class="content">（三）被保险人在投保前已经发生的或可以合理预见的诉讼、仲裁案件所产生的一切法律费用； </span>
      <span class="content">（四）等待期内发生的各类诉讼、仲裁案件引起的一切法律费用；</span>
      <span class="content">（五）免赔额。</span>
      <span class="content">（六）被保险人在投保人平台以外做公证、司法鉴定所产生费用或对非保险主体做公证、司法鉴定所产生的费用；</span>
      <span class="content">（七）被保险人过失、疏忽、故意或恶意申请保全导致的司法纠纷；</span>
      <span class="content">（八）被保险人的非法及违法行为；</span>
      <span class="content">（九）被保险人与投保人之间的司法纠纷；</span>
      <span class="content">（十）保险人或投保人举证与保险客体无关的司法纠纷，并被法院认可的；</span>
      <span class="content">（十一）保全数据在保全前非真实合法，或有既往司法纠纷；</span>
      <span class="content">（十二） 其他不属于本保险责任范围内的损失、费用和责任，保险人不负责赔偿。 </span>
    </p>

  </div>
</template>

<script>
  export default {
    name: "userNotes",
    mounted() {
    }
  }
</script>

<style lang="less" scoped>
  .user-notes {
    max-width: 1200px;
    margin: 0 auto;

    h4 {
      text-align: center;
      font-weight: 500;
      font-size: 18px;
      margin: 10px 0;
    }

    p {
      font-size: 14px;
      color: #333333;
      margin-bottom: 7px;

      span {
        display: block;
        margin: 0;
        padding: 0;
      }

      .content {
        text-indent: 28px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// pages/insure/userNotes.vue